export default __webpack_public_path__ + "info.3927f55c.svg";